import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/faq/HeroBanner";
import Faqs from "../components/faq/Faqs";


export default function Faq() {
    return (
        <>
            <Header />

            <HeroBanner />

            <Faqs />

            <Footer />
        </>
    );
}